// extracted by mini-css-extract-plugin
export default {"spinner--black":"spinner___spinner--black___2qXcF","spinner":"spinner___spinner___3_Hu0","spin-cycle":"spinner___spin-cycle___LvhNr"};